import { activityStatus, contentTags } from "Constants/constants";
import studentRecordService from "Services/StudentRecordService";
import {uuidToHEX} from "Services/util";
import studentInformationService from "Services/StudentInformationService";
import {getUserData, setUserData} from "Services/API";
import { recommendationModes } from "../constants/constants";

const saxonSequenceStart = [
  "03e43330-06ce-11ed-a162-a1297cf7ce20", //K
  "d0739f40-06e1-11ed-926f-2fafd63c7eab", //1st
  "682d0ac0-05e7-11ed-b2c3-19ea6141a283"  //2nd
]

export function endOfSaxonSequence(activity){
  if(!activity){
    return false;
  }
  const { status, story } = activity;
  const tags = (story.tags && story.tags.length) ? story.tags : [];
  return status === activityStatus.SCORED && tags.includes(contentTags.SAXON_SEQUENCE_END);
}

export async function shouldStartSaxonSequence(userId, isSaxonReader, grade){
  if(!isSaxonReader || grade > 2) return false;
  const hasSequenceInProgress = await hasSaxonSequenceInProgress(userId);

  return(isSaxonReader && !hasSequenceInProgress);
}

export async function hasSaxonSequenceInProgress(userId,locale='en-us'){
  const tutorActivities = await studentRecordService.getRecommendedStories(uuidToHEX(userId),0,"tutor",1,"",recommendationModes.SEQUENCE_LOCKED,locale);
  if(!tutorActivities.length){
    return false;
  }
  return tutorActivities.some(story => isSaxonStory(story));
}

export async function getSaxonSequenceStart(userId, isSaxonReader, grade, currentSequence){
  if(!isSaxonReader || grade > 2) return currentSequence;
  const hasSequenceInProgress = await hasSaxonSequenceInProgress(userId);
  if(!hasSequenceInProgress){
    currentSequence.push({storyId: saxonSequenceStart[grade], locale: 'en-us'});
  }

  return currentSequence;
}

export function isSaxon(activity) {
  const { storyTags } = activity;

  // return false if storyTags is null
  if (!storyTags) return false

  return (storyTags.includes(contentTags.SAXON_STORY));
}

export function isSaxonStory(story) {
  if(!story) return false;

  const storyTags = story && story.tags;
  if (!storyTags) return false

  return (storyTags.includes(contentTags.SAXON_STORY));
}

export function isSaxonrActivity(activity){
  if(!activity){
    return false;
  }
  const tags = (activity && activity.story && activity.story.tags && activity.story.tags.length) ? activity.story.tags : [];
  return(tags.includes(contentTags.SAXON_STORY));
}


export default {
  endOfSaxonSequence,
  shouldStartSaxonSequence,
  hasSaxonSequenceInProgress,
  getSaxonSequenceStart,
  isSaxon,
  isSaxonStory,
  isSaxonrActivity,
}
